define('controllers/modules/goal/goal',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'src/controller/controller',
    // controller
    'controllers/modules/calendar/calendar',
    // models
    'models/goal/goal',
    // views
    'views/modules/goal/goal-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent
    Controller,
    // controller
    CalendarCtrl,
    // models
    MGoal,
    // views
    VGoalPanel
) {

    var GoalCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*goal': 'index',
            ':goalId(/)': 'editRoute',
            'new(/)': 'newRoute',
        },

        subRoutes: {
            goal: '{{{goalId}}}',
            calendar: 'calendar/',
        },

        initialize: function(prefix, opt) {

            this.role = opt.role;

            this.ctrl = {
                calendar: new CalendarCtrl(
                    this.getPrefix('calendar', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.calendar,
                        role: this.role
                    }),
            };

            this.listenTo(this.ctrl.calendar, 'before:route', this.onCalendarRoute);
        },

        index: function(groupId, userId) {
            this.renderGoal(groupId, userId);
        },

        renderGoal: function(groupId, userId) {
            var layout = this.getLayout();
            layout.showMemberPage(groupId, userId, "goal");
            layout.getContent().toggleInfo(false);
        },

        _editRoute: function(goalId) {
            var view = this.initView(goalId);
            this.getLayout().getContent()
                .setInfoContent(view, { open: true });
        },

        ////////////
        // routes //
        ////////////

        editRoute: function(groupId, userId, goalId) {

            var view = this.initView(),
                content = this.getLayout().getContent();

            this.model.resetToId(goalId, { silent: true });

            return this.when([
                this.model.fetch(),
                content.toggleInfoOverlay(false)
            ]).then(this._editRoute(goalId));
        },

        newRoute: function(groupId, userId) {
            var view = this.initView(),
                content = this.getLayout().getContent();

            return this.when([
                content.toggleInfoOverlay(false)
            ]).then(function() {
                this.model.reset();
                content.setInfoContent(view, { open: true });
            });
        },

        initView: function(goalId) {
            if (!goalId)
              this.model = new MGoal();

            this.view = new VGoalPanel({
                url: this.url,
                model: this.model,
                profile: this.profile,
                role: this.role,
            });
            this.listenTo(this.view, 'back', this.onBack);

            return this.view;
        },

        ////////////
        // events //
        ////////////
        onBack: function() {
            Backbone.history.navigate(
                Mustache.render(this.url.root, {
                    userId: this.profile.id,
                    groupId: this.group.id
                }), { trigger: true });
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

        onCalendarRoute: function(route, params) {
            this.renderGoal.apply(this, params);
        },

    });

    return GoalCtrl;

});

